import { createChipsContentText } from 'common/components/Chips/utils/chipsContentUtils.ts';
import { DateRangeValuePiece } from 'common/components/Inputs/DateRangePickerMui/DateRangePickerMui.tsx';
import { TFunction } from 'i18next';
import {
  PROVISIONING_STATUS_TO_STATUS_LABEL_MAP,
  ProvisioningStatusFilter,
} from '@/activityLog/bulkProvisioning/constants/provisioningStatus.ts';

export const createDateRangeChipsContent = ({
  uploadDateFrom,
  uploadDateTo,
  t,
}: {
  uploadDateFrom: DateRangeValuePiece;
  uploadDateTo: DateRangeValuePiece;
  t: TFunction;
}) => {
  const from = uploadDateFrom ? `from ${new Date(uploadDateFrom).toLocaleDateString()}, ` : '';

  const to = uploadDateTo ? `to ${new Date(uploadDateTo).toLocaleDateString()}` : '';

  if (from || to) {
    return createChipsContentText(t('common.uploadDate'), `${from}${to}`);
  }
};

export const createStatusChipContent = ({
  status,
  t,
}: {
  status: ProvisioningStatusFilter;
  t: TFunction;
}) => {
  if (status !== '') {
    return createChipsContentText(
      t('common.status'),
      PROVISIONING_STATUS_TO_STATUS_LABEL_MAP[status],
    );
  }
};
